module.exports = __webpack_public_path__ + "img/geo-zones-1.98f4fab6.gif";